<template>
  <v-container v-if="currentIframeTournament" fluid>
      <v-layout row wrap>
          <v-flex xs12>
              <v-data-table
              :rows-per-page-items="[25,50,100]"
                  :headers="headers"
                  :items="currentIframeTournament.yellow_cards"
                  class="elevation-1"
                  light
                  hide-actions
                  no-results-text=""
                  >
                  <template slot="items" slot-scope="props">
                      <td class="text-xs-right">{{ props.index + 1  }}</td>
                      <td class="text-xs-right">{{ props.item.name }}</td>
                      <td class="text-xs-right">{{ props.item.team_name }}</td>
                      <td class="text-xs-right">{{ props.item.attendances }}</td>
                      <td class="text-xs-right">{{ props.item.yellow_cards }}</td>
                  </template>
              </v-data-table>
          </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Bus from '@/components/bus'


export default {
    name: 'IframeYellowCards',
    data() {
        return {
          headers: [
              { text: '#', value: 'position' },
              { text: 'Jugador', value: 'player' },
              { text: 'Equipo', value: 'team' },
              { text: 'JJ', value: 'games' },
              { text: 'TA', value: 'yCards' }
          ]
        }

    },
    computed:{
      ...mapGetters([
        "currentIframeTournament"
      ])
    },
    methods: {
      ...mapActions([

      ]),

    },
    mounted() {

    },
    created() {

    }
}

</script>

<style lang="css" scoped>


</style>



// WEBPACK FOOTER //
// src/components/pages/iframe/iframeYellowCards.vue